import Crud from "../Crud";

/**
 * Static helper functions related to Order Status Reasons.
 */
export default class OrderStatusReasonDetail extends Crud {

    /**
     * @param {object} orderStatusReasonDetail The orderStatusReasonDetail object.
     * @returns The display name of the orderStatusReasonDetail.
     */
    static getDisplayName(orderStatusReasonDetail) {
        if (!orderStatusReasonDetail) {
            return null;
        }

        return orderStatusReasonDetail.name;
    }

    /**
     * Determines if an orderStatusReasonDetail matches a search query.
     *
     * @param {object} orderStatusReasonDetail The orderStatusReasonDetail to test.
     * @param {string} query The search query.
     * @returns {boolean} Whether or not the orderStatusReasonDetail matches the query.
     */
    static match(orderStatusReasonDetail, query) {
        return (
            (orderStatusReasonDetail.description.toLowerCase().includes(query)) ||
            orderStatusReasonDetail.id === +query
        );
    }

    /**
     * @param {array} orderStatusReasonDetails The list to sort.
     * @returns {array} The sorted list.
     */
    static sort(orderStatusReasonDetails) {
        return orderStatusReasonDetails.sort((a, b) => a.name.localeCompare(b.name));
    }

    /**
     * @returns {string} The color of this object.
     */
    static getBaseColor() {
        throw new Error("Use orderStatus.colorId");
    }

    /**
     * @returns {string} The icon name for this object.
     */
    static getIconName() {
        return "Sell";
    }
}